export const REMOVE = '';
export const CAN_USE = 'can_use';
export const CAN_EDIT = 'can_edit';
export const EVERYONE_GROUP_ID = 'everyone';
export const CAN_USE_ENFORCED = 'can_use_enforce_on';

export const USER_MATCHING_ITEM_PREFIX = 'user_matched';

export const OPTIONS_MAP = {
	CAN_USE,
	CAN_USE_ENFORCED,
	CAN_EDIT,
};

const getOption = (value, text, subtext = '', disabled = false) => ({
	value,
	text,
	subtext,
	disabled,
});

export const ACTIONS = [{ divider: true }, getOption(REMOVE, 'Remove')];

export const FULL_ROLE_OPTIONS = [getOption(CAN_USE, 'Can use'), getOption(CAN_USE_ENFORCED, 'Can use (enforced on)')];

export const BASE_ROLE_OPTIONS = FULL_ROLE_OPTIONS.filter((opt) => opt.value !== CAN_USE_ENFORCED);
